import { FC, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';

type DateDisplayModeProps = {
  displayDate: string;
  onEdit: () => void;
};

export const DateDisplayMode: FC<DateDisplayModeProps> = ({ displayDate, onEdit }) => {
  const [showEditIcon, setShowEditIcon] = useState(false);

  const dateTextStyle = {
    color: 'rgba(13, 27, 39, 0.87)',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  };

  return (
    <Box
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
      onMouseEnter={() => setShowEditIcon(true)}
      onMouseLeave={() => setShowEditIcon(false)}
      onClick={onEdit}
    >
      <Typography variant="body2" sx={dateTextStyle}>
        {displayDate}
      </Typography>
      <IconButton size="small" sx={{ opacity: showEditIcon ? 1 : 0 }}>
        <VyIcon icon="Pen" transform="scale(0.8)" />
      </IconButton>
    </Box>
  );
};
